import React from 'react';
import PageBackground from '../../components/Layouts/PageBackground';
import Card from './components/Card';
import Carousel from '../../components/Carousel';
import Modal from 'react-modal';
import Close from '../../assets/images/howtoplay/carousel/close.png';
import { howtoplay } from '../../data';
import { useNavigate } from 'react-router-dom';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        padding: '0px!important',
        transform: 'translate(-50%, -50%)',
    },
};

const HowtoPlay = () => {
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const navigate = useNavigate();

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const handleInfoClick = (type) => {
        switch (type) {
            case "CLUBS":
                openModal();
                break;
            case "SWEEPSTAKES":
                navigate('/jackpot-sng')
                break;
            default:
                break;
        }
    }

    const handleSideInfoClick = (type) => {
        switch (type) {
            case "SWEEPSTAKES":
                navigate('/burn')
                break;
            default:
                break;
        }
    }

    return (
        <div>
            {
                <PageBackground
                    title="HOW TO PLAY"
                    howtoplay
                >

                    {howtoplay.map((object, i) => <Card data={object} key={i} infoClick={handleInfoClick} sideInfoClick={handleSideInfoClick} />)}
                    <div>
                        <Modal
                            isOpen={modalIsOpen}
                            onRequestClose={closeModal}
                            style={customStyles}
                            ariaHideApp={false}
                        >
                            <Carousel />
                            <button
                                className="closeButton"
                                onClick={closeModal}
                            >
                                <img src={Close} alt="close-button" />
                            </button>
                        </Modal>
                    </div>
                </PageBackground>
            }
        </div>
    );
};

export default HowtoPlay;
